export const environment = {
	production: false,
	firebase: {
		apiKey: "AIzaSyDKxSYjPeGhY0fWr5EHzmygjUPx6Di4zYQ",
		authDomain: "devedvlportal.firebaseapp.com",
		databaseURL: "https://devedvlportal.firebaseio.com",
		projectId: "devedvlportal",
		storageBucket: "devedvlportal.appspot.com",
		messagingSenderId: "278120608598"
	},
	functionsURL: 'https://us-central1-edvlportal.cloudfunctions.net'
};
